export const getDefaultTemplate = (): string => {
  return `
    <h2 style="font-size: 24px; font-weight: 600; color: #111827; margin-top: 32px; margin-bottom: 16px;">1. Résumé Exécutif</h2>
    <p style="line-height: 1.75; color: #374151; margin-bottom: 16px;">
      Ce document présente le rapport détaillé du projet. Il inclut une analyse complète des objectifs,
      des résultats obtenus, ainsi que des recommandations pour les prochaines étapes.
    </p>

    <h2 style="font-size: 24px; font-weight: 600; color: #111827; margin-top: 32px; margin-bottom: 16px;">2. Contexte du Projet</h2>
    <p style="line-height: 1.75; color: #374151; margin-bottom: 16px;">
      Le projet a été initié dans le but de répondre aux besoins suivants :
    </p>
    <ul style="line-height: 1.75; color: #374151; margin-bottom: 16px; padding-left: 24px;">
      <li>Améliorer l'efficacité opérationnelle</li>
      <li>Réduire les coûts de maintenance</li>
      <li>Optimiser la satisfaction client</li>
      <li>Moderniser les infrastructures existantes</li>
    </ul>

    <h2 style="font-size: 24px; font-weight: 600; color: #111827; margin-top: 32px; margin-bottom: 16px;">3. Méthodologie</h2>
    <p style="line-height: 1.75; color: #374151; margin-bottom: 16px;">
      Notre approche s'est articulée autour de plusieurs phases clés :
    </p>
    <ol style="line-height: 1.75; color: #374151; margin-bottom: 16px; padding-left: 24px;">
      <li><strong>Phase de découverte :</strong> Analyse des besoins et des contraintes</li>
      <li><strong>Phase de conception :</strong> Élaboration des solutions techniques</li>
      <li><strong>Phase d'implémentation :</strong> Mise en œuvre des solutions</li>
      <li><strong>Phase de validation :</strong> Tests et ajustements</li>
    </ol>

    <h2 style="font-size: 24px; font-weight: 600; color: #111827; margin-top: 32px; margin-bottom: 16px;">4. Résultats Obtenus</h2>
    <p style="line-height: 1.75; color: #374151; margin-bottom: 16px;">
      Les principaux résultats du projet sont les suivants :
    </p>
    <blockquote style="border-left: 4px solid #d1d5db; padding-left: 16px; margin: 16px 0; color: #4b5563; font-style: italic;">
      "Une amélioration significative de 35% de l'efficacité opérationnelle a été constatée
      suite à la mise en place des nouvelles solutions."
    </blockquote>
    <p style="line-height: 1.75; color: #374151; margin-bottom: 16px;">
      Les indicateurs de performance ont tous dépassé les objectifs fixés initialement,
      démontrant la pertinence des choix technologiques effectués.
    </p>

    <h2 style="font-size: 24px; font-weight: 600; color: #111827; margin-top: 32px; margin-bottom: 16px;">5. Recommandations</h2>
    <p style="line-height: 1.75; color: #374151; margin-bottom: 16px;">
      Pour capitaliser sur ces résultats, nous recommandons :
    </p>
    <ul style="line-height: 1.75; color: #374151; margin-bottom: 16px; padding-left: 24px;">
      <li>Poursuivre le déploiement sur l'ensemble des sites</li>
      <li>Former les équipes aux nouvelles procédures</li>
      <li>Mettre en place un suivi mensuel des indicateurs</li>
      <li>Planifier une phase d'optimisation continue</li>
    </ul>

    <hr style="margin: 48px 0; border: none; border-top: 1px solid #e5e7eb;" />

    <h2 style="font-size: 24px; font-weight: 600; color: #111827; margin-top: 32px; margin-bottom: 16px;">6. Conclusion</h2>
    <p style="line-height: 1.75; color: #374151; margin-bottom: 16px;">
      Ce projet constitue une étape importante dans notre stratégie de transformation.
      Les résultats obtenus valident notre approche et ouvrent la voie à de nouvelles opportunités
      d'amélioration et d'innovation.
    </p>
    <p style="line-height: 1.75; color: #374151; margin-bottom: 32px;">
      Nous restons à votre disposition pour toute question ou complément d'information concernant ce rapport.
    </p>

    <div style="margin-top: 64px; padding-top: 24px; border-top: 1px solid #e5e7eb; color: #6b7280; font-size: 12px;">
      <p style="margin: 0;">Document confidentiel</p>
    </div>
  `;
};
